import { IOptionSelect } from "src/@types/form";
import { LegalForm } from "../types";

//  common options - (from)
export const LEGAL_FORM_OPTIONS: IOptionSelect[] = [
  {
    id: 1,
    value: LegalForm.indEnt,
    label: "Фізична особа-підприємець",
  },
  {
    id: 2,
    value: LegalForm.legEnt,
    label: "Юридична особа",
  },
];

export const YES_NO_OPTIONS: IOptionSelect[] = [
  {
    id: 1,
    value: true,
    label: "Так",
  },
  {
    id: 2,
    value: false,
    label: "Ні",
  },
];
// (to)

//  options for individual-entrepreneur (ФОП) - (from)
export const IND_ENT_TAXATION_SYSTEM_OPTIONS: IOptionSelect[] = [
  {
    id: 1,
    value: "спрощена",
    label: "Спрощена",
  },
  {
    id: 2,
    value: "загальна",
    label: "Загальна",
  },
];

export const IND_ENT_SINGLE_TAX_GROUP_OPTIONS: IOptionSelect[] = [
  {
    id: 1,
    value: "2-група",
    label: "2 група",
  },
  {
    id: 2,
    value: "3-група",
    label: "3 група",
  },
];
// (to)

//  options for legal entity (ЮО) - (from)
export const LEG_ENT_TAXATION_SYSTEM_OPTIONS: IOptionSelect[] = [
  {
    id: 1,
    value: "спрощена",
    label: "Спрощена",
  },
  {
    id: 2,
    value: "загальна",
    label: "Загальна",
  },
];

export const LEG_ENT_SINGLE_TAX_GROUP_OPTIONS: IOptionSelect[] = [
  {
    id: 1,
    value: "3-група",
    label: "3 група",
  },
  {
    id: 2,
    value: "4-група",
    label: "4 група",
  },
];
// (to)
